import { LitElement, html, css, Splide, Swup } from '@hh/global.js'

const swup = new Swup({
  containers: ['.hh-swup'],
  linkSelector: '.js-swup-link',
  timeout: 10000,
})

swup.hooks.on('visit:start', (visit) => {
  visit.scroll.reset = false
})

class ProductDetail extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.initializeMediaSplide()
    this.initializeVariantSplide()
    this.checkVIPDiscount()
    this.connectAppsOnSwupTransition()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  connectAppsOnSwupTransition() {
    if (typeof window.yotpo?.initWidgets === 'function') {
      window.yotpo?.initWidgets()
    }

    if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
      window.yotpoWidgetsContainer?.initWidgets()
    }
  }

  initializeMediaSplide() {
    const carouselEl = this.querySelector(
      '.js-product-detail-media-mobile-splide'
    )
    if (!carouselEl) return

    this.productMediaMobileVariantSplide = new Splide(carouselEl, {
      arrows: false,
      pagination: true,
      useScroll: true,
      mediaQuery: 'min',
      type: 'fade',
      cloneStatus: false,
      rewind: true,
      start: 0,
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    })

    this.productMediaMobileVariantSplide.on('pagination:mounted', (data) => {
      const mediaVideoEls =
        this.querySelectorAll('[data-product-detail-media-video]') || []

      data.items.forEach((item) => {
        const curPage = item.page
        const isVideoEl = Array.from(mediaVideoEls).some(
          (item) => item?.dataset.productDetailMediaVideo === String(curPage)
        )

        if (isVideoEl) {
          item.button.classList.add(
            'product-details__media-mobile-splide-pagination-item-video'
          )
        }
      })
    })

    this.productMediaMobileVariantSplide.mount()
  }

  initializeVariantSplide() {
    const carouselEl = this.querySelector(
      '.js-product-detail-footer-variant-splide'
    )
    if (!carouselEl) return

    this.productFooterMobileVariantSplide = new Splide(carouselEl, {
      arrows: false,
      pagination: false,
      fixedWidth: '64px',
      gap: 12,
      padding: { left: 14, right: 14 },
      useScroll: true,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    }).mount()
  }

  checkVIPDiscount() {
    const cookies = Object.fromEntries(
      document.cookie
        .split('; ')
        .map((v) => v.split(/=(.*)/s).map(decodeURIComponent))
    )

    const vipPromoEL = this.querySelectorAll('.js-product-card-vip-promo')

    vipPromoEL.forEach((el) => {
      if (!('discount_code' in cookies)) {
        el.classList.remove('hidden')
      }
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('product-detail', ProductDetail)

class ProductIndigloToggle extends LitElement {
  static properties = {
    checked: {
      type: Boolean,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  _handleButton() {
    const indigloButtons = document.querySelectorAll('indiglo-toggle')
    const productDetailEl = this.closest('product-detail')

    if (!productDetailEl.classList.contains('show-indiglo') && !this.checked) {
      productDetailEl.classList.add('show-indiglo')
    } else {
      productDetailEl.classList.remove('show-indiglo')
    }

    indigloButtons.forEach((item) => {
      item.toggleAttribute('checked')
    })
  }

  static styles = css`
    :host button {
      position: relative;
      padding: 4px;
      border: none;
      border-radius: 100px;
      width: 70px;
      height: 36px;
      background-color: #e8e8e8;
      transition: background-color 250ms ease;
      cursor: pointer;
    }

    :host([checked]) button {
      background-color: #3a3a3a;
    }

    :host span[data-toggle-thumb] {
      display: block;
      width: 28px;
      height: 28px;
      background-color: #ffffff;
      border-radius: 9999px;
      transition: transform 250ms ease, background-color 250ms ease;
      transform: translateX(0px);
      will-change: transform;
    }

    :host span[data-toggle-thumb][data-state='checked'] {
      background-color: #000000;
      transform: translateX(34px);
    }

    :host .indiglo-toggle__icons {
      position: absolute;
      inset: 4px 9.5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: color 250ms ease;
      z-index: 1;
      color: #000;
    }

    :host([checked]) .indiglo-toggle__icons {
      color: #fff;
    }

    :host([checked]) .indiglo-toggle__icons svg:first-of-type {
      color: #bbbbbb;
    }
  `

  render() {
    return html`<button
      type="button"
      role="switch"
      aria-checked="${this.checked ? 'true' : 'false'}"
      aria-label="Preview INDIGLO Night-Light Feature"
      @click="${this._handleButton}"
    >
      <div class="indiglo-toggle__icons">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="4.5" stroke="currentColor" />
          <path d="M8 0V2" stroke="currentColor" />
          <path d="M14 8H16" stroke="currentColor" />
          <path d="M8 14V16" stroke="currentColor" />
          <path d="M0 8H2" stroke="currentColor" />
          <path d="M13.6567 2.34326L12.2425 3.75748" stroke="currentColor" />
          <path d="M12.2427 12.2427L13.6569 13.6569" stroke="currentColor" />
          <path d="M3.75732 12.2427L2.34311 13.6569" stroke="currentColor" />
          <path d="M2.34326 2.34326L3.75748 3.75748" stroke="currentColor" />
        </svg>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.31627 1.00032C5.26513 1.00287 5.21527 1.0131 5.16797 1.031C2.52079 2.01226 1 4.58398 1 7.51051C1 11.3198 4.0946 14.4196 7.90401 14.4196C10.8305 14.4196 13.4073 12.8937 14.3886 10.2465C14.4551 10.0644 14.4078 9.86043 14.2684 9.72556C14.1297 9.59067 13.9238 9.5504 13.7442 9.62263C13.0743 9.89176 12.3379 10.0318 11.5605 10.0318C8.35331 10.0318 5.38783 7.06121 5.38783 3.85402C5.38783 3.07669 5.52271 2.34027 5.79185 1.67029C5.85194 1.51623 5.83084 1.34172 5.73495 1.20684C5.63907 1.07196 5.48184 0.993919 5.31627 1.00032ZM4.55429 2.42714C4.45904 2.88931 4.40599 3.36556 4.40599 3.85396C4.40599 7.65241 7.76209 11.0136 11.5605 11.0136C12.0483 11.0136 12.5252 10.9554 12.9874 10.8602C11.962 12.5043 10.0998 13.4376 7.90411 13.4376C4.62541 13.4376 1.98199 10.7891 1.98199 7.51044C1.98199 5.31395 2.90946 3.4524 4.55429 2.42714Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <span
        data-state="${this.checked ? 'checked' : 'unchecked'}"
        data-toggle-thumb
      ></span>
    </button>`
  }
}

customElements.define('indiglo-toggle', ProductIndigloToggle)

class ProductDetailsBreadcrumb extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleViewMoreButton()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleViewMoreButton() {
    const viewMoreButtonEl = this.querySelector(
      '.js-product-details-breadcrumb-view-btn'
    )
    const breadcrumbItems = this.querySelector(
      '.js-product-details-breadcrumb-items'
    )

    viewMoreButtonEl?.addEventListener('click', (e) => {
      breadcrumbItems.classList.add('show-all')
      e.target.classList.add('hidden')
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

if (typeof customElements.get('product-details-breadcrumb') === 'undefined') {
  customElements.define('product-details-breadcrumb', ProductDetailsBreadcrumb)
}

class ProductStickyAtc extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    setTimeout(() => {
      this.classList.remove('is-show')
    }, 100)

    this.handleDesktopScroll()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleDesktopScroll() {
    const desktopMainAtc = document.querySelector(
      'div.product-details__panel-button-group.js-product-details-panel-cta-group'
    )
    const footer = document.querySelector('.footer')

    const intersectionOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === desktopMainAtc) {
          if (entry.isIntersecting || entry.boundingClientRect.top > 0) {
            this.classList.remove('is-show')
          } else {
            this.classList.add('is-show')
            this.classList.remove('is-hidden')
          }
        } else if (entry.target === footer) {
          if (entry.isIntersecting) {
            this.classList.remove('is-show')
          } else {
            this.classList.add('is-show')
          }
        }
      })
    }, intersectionOptions)

    this.observer.observe(desktopMainAtc)
    this.observer.observe(footer)
  }

  render() {
    return html`<slot></slot>`
  }
}

if (typeof customElements.get('product-detail-sticky-atc') === 'undefined') {
  customElements.define('product-detail-sticky-atc', ProductStickyAtc)
}

class ProductDetailsGwpCard extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleCloseButton()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleCloseButton() {
    const closeBtnEl = this.querySelector('.js-product-details-gwp-card-close')

    closeBtnEl.addEventListener('click', () => {
      this.classList.add('hidden')
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('product-details-gwp-card', ProductDetailsGwpCard)

class ProductSizeChart extends LitElement {
  static properties = {
    url: {
      type: String,
    },
    primaryDimension: {
      reflect: true,
      type: Number,
      attribute: 'primary-dimension',
    },
    primaryMeasurement: {
      type: String,
      attribute: 'primary-measurement',
    },
    primaryTitle: {
      type: String,
      attribute: 'primary-title',
    },
    secondaryDimension: {
      reflect: true,
      type: Number,
      attribute: 'secondary-dimension',
    },
    secondaryMeasurement: {
      type: String,
      attribute: 'secondary-measurement',
    },
    secondaryTitle: {
      type: String,
      attribute: 'secondary-title',
    },
    _imgSrc: {
      state: true,
    },
  }

  constructor() {
    super()
    this.url =
      this.primaryDimension =
      this.primaryMeasurement =
      this.primaryTitle =
      this.secondaryDimension =
      this.secondaryMeasurement =
      this.secondaryTitle =
      this._imgSrc =
        ''
  }

  connectedCallback() {
    super.connectedCallback()
    this.generateImageSource()
    this.onSizeGuideClick()
  }

  static styles = css`
    :host {
      border: 1px solid var(--theme-color-button-outlines);
    }

    :host img {
      width: 100%;
    }
  `

  generateImageSource() {
    return `${this.url}${this.primaryDimension}-${this.primaryMeasurement}-${this.primaryTitle}-${this.secondaryDimension}-${this.secondaryMeasurement}-${this.secondaryTitle}.png`
  }

  showSizeImage() {
    return html` <div class="size-guide__image">
      <img src="${this.generateImageSource()}" alt="Size Chart Image" />
    </div>`
  }

  onSizeGuideClick() {
    const DimensionRadioInputs = this.querySelectorAll(
      '.size-guide__primary-dimension input[type="radio"]'
    )

    DimensionRadioInputs.forEach((dimensionInput) => {
      dimensionInput.addEventListener('change', (e) => {
        if (dimensionInput.dataset.handle == this.primaryTitle) {
          this.primaryDimension = dimensionInput.value
        }

        if (dimensionInput.dataset.handle == this.secondaryTitle) {
          this.secondaryDimension = dimensionInput.value
        }
      })
    })
  }

  render() {
    return html`
      <slot></slot>
      ${this.showSizeImage()}
    `
  }
}
customElements.define('product-size-chart', ProductSizeChart)
